module.exports = __webpack_public_path__ + "static/img/01.816d97c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/03-hyCase/01.jpg
// module id = Cyza
// module chunks = 1